import { render, staticRenderFns } from "./FormulaContainer.vue?vue&type=template&id=4c2c7fb9&scoped=true&"
import script from "./FormulaContainer.vue?vue&type=script&lang=js&"
export * from "./FormulaContainer.vue?vue&type=script&lang=js&"
import style0 from "./FormulaContainer.vue?vue&type=style&index=0&id=4c2c7fb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c7fb9",
  null
  
)

export default component.exports